
var accesskey_secret = "LTAI4FqcZCnwSy8bZ4Y78wJ1";
import md5 from 'js-md5';
export  function _sign(params) {
    /*
        @params object: uri请求参数(包含除signature外的公共参数)
    */
    if( typeof(params)!="object" ) {
        console.error("params is not an object");
        return false;
    }
    // NO.1 参数排序
    var _my_sorted = Object.keys(params).sort();
    // NO.2 排序后拼接字符串
    var canonicalizedQueryString = '';
    for (var _i in _my_sorted) {
        canonicalizedQueryString += _my_sorted[_i] + '=' + params[_my_sorted[_i]] + '&';
    }
    canonicalizedQueryString += accesskey_secret
    // NO.3 加密返回签名: signature
    return md5(canonicalizedQueryString).toUpperCase();
}


// WEBPACK FOOTER //
// ./src/utils/sign.js